export default __webpack_public_path__ + "static/media/startloading_background2.eb1356da.jpg";